// Manual feature flags (mirror of the maintenance toggle pattern). Flip + redeploy.
//
// Android share-to-Heldall kill switch. When false, the app stops consuming shared payloads
// and shows a calm fallback. NOTE: the load-bearing kill switch is the matching constant in
// public/service-worker.js — it stops the payload being processed even if an installed PWA
// still has a cached manifest `share_target`. To fully disable: set BOTH to false and redeploy
// (optionally also remove `share_target` from manifest.json so new installs don't offer it).
export const ENABLE_ANDROID_SHARE_TARGET = false;
